function ViewMessageIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9 0H2.1C1.22 0 .5.72.5 1.6V16l3.2-3.2h11.2c.88 0 1.6-.72 1.6-1.6V1.6c0-.88-.72-1.6-1.6-1.6z"
        fill="#4079F5"
      />
      <path
        d="M7.272 11.433l-.066.167.066.167c1.072 2.744 3.72 4.693 6.828 4.693 3.107 0 5.756-1.949 6.829-4.693l.065-.167-.066-.167C19.857 8.689 17.209 6.74 14.1 6.74c-3.107 0-5.756 1.949-6.828 4.693zm6.828 2.64c-1.348 0-2.449-1.104-2.449-2.473 0-1.369 1.1-2.473 2.45-2.473 1.347 0 2.448 1.104 2.448 2.473 0 1.369-1.1 2.473-2.449 2.473zm0-4.693a2.21 2.21 0 00-2.205 2.22 2.21 2.21 0 002.205 2.22 2.21 2.21 0 002.205-2.22A2.21 2.21 0 0014.1 9.38z"
        fill="#4079F5"
        stroke="#fff"
        strokeWidth={0.92}
      />
    </svg>
  )
}

export default ViewMessageIcon
